<script>
  import resources from './resources'

  export default {
    name: 'professional-schedulings-index',
    mixins: [resources]
  }
</script>

<template lang="pug">
  .col-xs-12.col-sm-9.col-md-10.content-wrapper
    .inner-title.two-lines
      h2
        span.first-line
          span.icon 
          |  Minha Agenda
        span.hifen  —
        span.second-line Lista de Agendamentos

    .col-xs-12.content
      div.hidden-md.hidden-lg
        br
        br
        router-link(:to="{name: 'patient.agendas.search'}")
          button.btn.btn-primary.zero-margin(type='button')
            span.icon 
            |  Novo Agendamento

      .container-fluid
        .row
          router-link.hidden-xs(:to="{name: 'patient.agendas.search'}", style="float: right")
            button.btn.btn-primary.zero-margin(type='button')
              span.icon 
              |  Novo Agendamento

          ul.nav.nav-tabs
              li.active
                  a(href="") Agendados
              li
                router-link(:to="{ name: 'patient.agendas.schedulings.history'}")
                  | Histórico
          .col-xs-12.white-bg
            .row(v-if="loading")
              spinner(:show="true")
            .row(v-if="!loading")
              .agendamentos.col-xs-12.white-bg(v-if="schedules.length === 0")
                h3
                  center.m-t-50 Nenhum evento localizado.
              .agendamentos.col-xs-12.white-bg(v-if="schedules.length > 0")
                .row.hidden-xs.hidden-sm
                  .col-xs-12.col-sm-1.col-title.active Data
                  .col-xs-12.col-sm-1.col-title Hora
                  .col-xs-12.col-sm-3.col-title Paciente
                  .col-xs-12.col-sm-3.col-title Professional
                  .col-xs-12.col-sm-2.col-title Especialidade
                  .col-xs-12.col-sm-1.col-title Situação
                  .col-xs-12.col-sm-1.col-title.action-title Ação
                .row
                  ul
                    schedule(v-for='schedule in schedules', :key='schedule.id', :schedule='schedule')
                .row
                .row
                  .col-xs-12.col-sm-3
                    button.btn.exclude-filled(v-if="hasSelected", @click="doCancel()")
                      span.icon 
                      | Cancelar Selecionados
                  .col-xs-12.col-sm-9
              .pagination
                pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>
<style scpode>
h3 {
  font-weight: lighter;
  margin-top: 0;
  margin-bottom: 30px;
}
.m-t-50 {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/app/patient/agendas/schedulings/scheduled/index/index.vue